import { Row, Col } from "antd";
import {
  DollarSign,
  Printer,
  Book,
  FileCheck,
  Lightbulb,
  Send,
  CheckSquare,
} from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function GeneralFor7And13(props) {
  const { verification, setVerification, hidden, loading } = props;

  return (
    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={8}>
      <DataGroup
        title={"General"}
        formName={"Información general"}
        mainData={verification}
        setMainData={setVerification}
        verification={verification}
      >
        <DataItem
          keyName="Descripción breve"
          value={verification?.DescripcionBreve}
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<DollarSign size={16} />}
          iconColor="#82cc4b "
          keyName="Monto de contrato"
          value={verification?.Monto}
          valueType="double"
          fieldWidth={8}
          hidden={hidden}
          prefix="$"
          loading={loading}
        />
        <DataItem
          icon={<Printer size={16} />}
          iconColor="#1890ff "
          keyName="Folio interno"
          value={verification?.FolioAmuvie}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Book size={16} />}
          iconColor="#802917 "
          keyName="Folio Sediver"
          value={verification?.FolioSediver}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          keyName="Tipo de verificación"
          icon={<FileCheck size={16} />}
          iconColor="black"
          value={verification?.TipoVerificacion}
          valueType="string"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Lightbulb size={16} />}
          iconColor="darkgoldenrod"
          keyName="Carga instalada"
          value={verification?.CargaInstalada}
          valueType="double"
          suffix="kW"
          fieldWidth={16}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<Send size={16} />}
          iconColor="#82cc4b"
          keyName="Fecha de la solicitud"
          value={verification?.FechaRecepcion}
          valueType="date"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
        <DataItem
          icon={<CheckSquare size={16} />}
          iconColor="#ffc53d"
          keyName="Fecha de emisión"
          value={verification?.FechaEmision}
          valueType="date"
          fieldWidth={8}
          hidden={hidden}
          loading={loading}
        />
      </DataGroup>
    </Col>
  );
}